import { EPublisherEventValue } from 'components/Settings/Settings.types';

export enum ELocalStorageKeys {
  JWT_TOKEN = 'jwt_token',
  JWT_TOKEN_TTL = 'jwt_token_ttl',
  USER_DETAILS = 'user_details',
  BUNDLES_COLUMN_VISIBILITY = 'bundlesColumnVisibility',
  ORDERS_COLUMN_VISIBILITY = 'columnVisibility',
  PRODUCTS_COLUMN_VISIBILITY = 'productsColumnVisibility',
  TAGS_COLUMN_VISIBILITY = 'tagsColumnVisibility',
  ENVIRONMENT = 'env',
  MOCK_API = 'mock_api',
  FEATURE_FLAGS = 'feature_flags',
  OVERRIDE_STATS = 'override_stats',
  OVERRIDE_TRENDS = 'override_trends',
  PUBLISHER_ID = 'publisher_id',
  PUBLISHER_SOLUTION_MODEL = 'publisher_solution_model',
  PERMISSIONS = 'permissions',
  FINANCIAL_REPORTS_INFO_BANNER_CLOSED = 'financial_reports_info_banner_closed',
  NEW_MENU_TABS_SEEN = 'new_menu_tabs_seen',
  PROJECTS_PAGE_TYPES = 'projects_page_types',
  LAST_VIEWED_PROJECTS = 'last_viewed_projects',
  PROJECTS_SORT_PREFERENCE = 'projects_sort_preference',
  PROJECTS_VIEW_PREFERENCE = 'projects_view_preference',
  STARRED_PROJECTS = 'starred_projects',
  SESSION_ID = 'session_id',
  ZENDESK_TOKEN = 'zendesk_token',
  PREVIEW_DEVICE_LAYOUT = 'preview_device_layout',
  TEST_PERSONALIZATION_PANEL_WIDTH = 'test_personalization_panel_width',
  PLAYER_DATA = 'playerData',
  COUPONS_PROMO_CODES_INFO_BANNER_CLOSED = 'coupons_promo_codes_info_banner_closed'
}

export enum ELambdaProfilesEndpoints {
  PUBLISHER_EVENT_WEBHOOK = 'publisherEventWebhook',
  PIS_URL = 'playerInfoSync',
  AUTH = 'authentication',
  ORDER_REPORTING = 'orderReporting'
}

export enum ENotificationType {
  ERROR = 'error',
  WARNING = 'warring',
  INFO = 'info',
  SUCCESS = 'success'
}

export enum EFieldState {
  DEFAULT = 'default',
  ERROR = 'error',
  SUCCESS = 'success'
}

export enum EQueryKeys {
  COUPONS = 'coupons',
  CHECKLIST_TASKS = 'checklist_tasks',
  TEMPLATES_STUDIO = 'templates_studio',
  COUPONS_CONFIGURATION = 'coupons_configuration',
  SINGLE_COUPON = 'single_coupon',
  BUNDLES = 'bundles',
  ORDERS = 'orders',
  CURRENCIES = 'currencies',
  SUPPORTED_CURRENCIES = 'supported_currencies',
  DISABLED_CURRENCIES = 'disabled_currencies',
  FINANCIAL_CONFIGURATION = 'financial_configuration',
  ORDER_DETAILS = 'order_details',
  PRODUCTS = 'products',
  PRODUCT = 'product',
  TAGS = 'tags',
  USERS = 'users',
  IMAGES = 'images',
  INTEGRATION = 'integration',
  APPSFLYER_INTEGRATION = 'appsflyer_integration',
  PROFILES = 'profiles',
  PUBLISHER = 'publisher',
  PUBLISHER_SETTINGS = 'publisher_settings',
  PLAYERS = 'players',
  BLOCKED_PLAYERS = 'blocked_players',
  USERS_BY_PUBLISHER = 'users_by_publisher',
  SEGMENTS = 'segments',
  PUBLISHER_TAGS = 'offer-tags',
  GRAPHS = 'graphs',
  BARS = 'bars',
  PIES = 'pies',
  FLAT_STATS = 'flat_stats',
  STORE_THEME = 'store_theme',
  GENERAL_THEME = 'general_theme',
  LOGIN_THEME = 'login_theme',
  STORE_SCREEN = 'store_screen',
  CHECKOUT_THEME = 'checkout_theme',
  COMPLETED_THEME = 'completed_theme',
  RECEIPT_THEME = 'receipt_theme',
  ANALYTICS = 'analytics',
  ANALYTICS_ATTRIBUTES = 'analytics_attributes',
  PRICING = 'pricing',
  PAYMENTS = 'payments',
  GEO = 'geo',
  REFUND = 'refund',
  OFFER_DESIGN = 'offer_design',
  CHECKOUT_DESIGNS = 'checkout_designs',
  BADGES = 'badges',
  OFFERS = 'offers',
  TRENDS = 'trends',
  BREAKDOWNS = 'breakdowns',
  AWARDING_V2_CHART = 'awarding_v2_chart',
  FINANCIAL_REPORTS = 'report',
  PAYOUTS = 'payouts',
  SECTIONS = 'sections',
  SECTIONS_BY_OFFER_TYPE = 'sections_by_offer_type',
  TABS = 'tabs',
  FEATURE_FLAGS = 'feature_flags',
  PRICING_POINTS_TEMPLATE = 'pricing_points_template',
  ROLES = 'roles',
  LOCALIZATION_ADDED_LANGUAGES_LIST = 'localization_added_languages_list',
  LOCALIZATION_STATIC_TRANSLATIONS_FILE = 'localization_static_translations_file',
  LOCALIZATION_DYNAMIC_TRANSLATIONS_FILE = 'localization_dynamic_translations_file',
  LOCALIZATION_STATIC_TRANSLATIONS_FILE_LAST_UPDATE = 'localization_static_translations_file_last_update',
  LOCALIZATION_DYNAMIC_TRANSLATIONS_FILE_LAST_UPDATE = 'localization_dynamic_translations_file_last_update',
  STORE_SETTINGS = 'store_settings',
  PAGES = 'pages',
  PAGES_EDIT_BLOCKS = 'pages_edit_blocks',
  CONTENT_MANAGEMENT_GET_CONTENTS_DATA = 'content_management_get_contents_data',
  CONTENT_MANAGEMENT_GET_CONTENT_BY_ID = 'content_management_get_content_by_id',
  PORTAL_SETTINGS = 'portal_settings',
  DISTRIBUTION_MANAGER = 'distribution_manager',
  LOTTIE_ANIMATION = 'lottie_animation',
  ALLOWED_PROJECTS = 'allowed_projects',
  SUBSCRIPTION_PLANS = 'subscription_plans',
  SUBSCRIPTION_PLAN = 'subscription_plan',
  SUBSCRIPTIONS = 'subscriptions',
  MEATADATA_ASSETS = 'metadata_assets',
  INTEGRATION_TEST = 'integration_test',
  PORTAL_TAGS = 'portal_tags',
  API_PERFORMANCE = 'api_performance',
  CREDENTIALS = 'credentials'
}

export enum EAssetType {
  BG_BUNDLE = 'bgBundle',
  BG_DESKTOP = 'bgDesk',
  BG_MOBILE = 'bgMobile',
  BG_POPUP = 'bgPopup',
  FAVICON = 'favicon',
  LOGO = 'logo',
  RECEIPT_LOGO = 'receiptLogo',
  BADGE = 'badge',
  PRODUCT = 'product',
  PRODUCT_PREFIX = 'productPrefix',
  GENERAL = 'general',
  SECTION = 'section',
  BANNER = 'banner',
  OFFER_HEADER = 'offerHeader',
  ADD_TO_HOME_BUTTON_IMAGE = 'addToHomeButtonImage',
  ADD_TO_HOME_ICON_IMAGE = 'addToHomeIconImage',
  PLAYER_PROFILE_IMG = 'playerProfileImage',
  BACK_TO_GAME_BUTTON_IMAGE = 'backToGameButtonImage',
  ANIMATION = 'animation',
  RECEIPT_HEADER = 'receiptHeader',
  TRAIT = 'trait',
  BUTTON_ASSET_SUFFIX = 'buttonAssetSuffix',
  SEO = 'seo',
  CUSTOM_ARROW = 'customArrow'
}

export enum ESectionOfferType {
  BUNDLE = 'bundle',
  PROMOTION = 'promotion'
}

export enum EBundlesInternalViewModel {
  AK = 'ak',
  MATCH = 'match',
  CANDIVORE = 'candivore',
  COMMUNIX2 = 'communix2',
  MAIN_SUB = 'mainSub',
  BAGELCODE2 = 'bagelcode2',
  LOCO_BINGO = 'locobingo',
  JACKPOT_SLOTS = 'jackpot-slots',
  BIG_FISH_CASINO = 'big-fish-casino',
  CASHMAN_CASINO = 'cashman-casino',
  LIGHTNING_LINK_CASINO = 'lightning-link-casino',
  HEART_OF_VEGAS = 'heart-of-vegas',
  ME2ON = 'me2on',
  EVERGREEN_DYNAMIC = 'evergreen-dynamic',
  PLAY_SIMPLE = 'play-simple',
  PIPA = 'pipa',
  WHISPERS = 'whispers',
  BABA = 'baba',
  MIGHTY_FU_CASINO = 'mighty-fu-casino',
  GHOST = 'ghost',
  GHOST_DOUBLE_HIT_CASINO = 'ghost-double-hit-casino',
  BINGO_POP = 'bingo-pop',
  LIGHTNING_LINK_CASINO2 = 'lightning-link-casino2',
  DYNAMIC_HEART_OF_VEGAS = 'dynamic-heart-of-vegas',
  FABEL_TOWN = 'fabel-town',
  DYNAMIC_MIGHTY_FU_CASINO = 'dynamic-mighty-fu-casino',
  DECA = 'deca',
  LOAD_COMPLETE = 'load-complete',
  DYNAMIC_CASH_MAN_CASINO = 'dynamic-cash-man-casino',
  PLAYDOG = 'playdog',
  SPIN_X = 'spin-x',
  CASH_FRENZY = 'cash-frenzy',
  GENNMU = 'gennmu',
  JUNES_JOURNEY = 'junes-journey',
  BANDITOS = 'banditos',
  ROYAL_BLAST = 'royal-blast',
  STUDIO_DEFAULT_LINEAR = 'studio-default-linear',
  STUDIO_DEFAULT_TWO_IN_ONE = 'studio-default-two-in-one',
  STUDIO_DEFAULT_THREE_IN_ONE = 'studio-default-three-in-one',
  DRIMAGE = 'drimage',
  ROYAL_MATCH = 'royal-match',
  CANDY_CRUSH = 'candy-crush',
  COOKING_MADNESS = 'cooking-madness',
  KONAMI_SLOTS = 'konami-slots',
  BEACHBUM = 'beachbum',
  MGM = 'mgm',
  MY_VEGAS_SLOTS = 'my-vegas-slots',
  MY_VEGAS_CLASSIC = 'my-vegas-classic',
  POP_SLOTS = 'pop-slots'
}

export enum BannerAspectRatio {
  SQUARE = '1 / 1',
  TWO_ON_THREE = '2 / 3'
}

export enum ESpecialOfferInternalViewModel {
  HUGE = 'hug',
  MATCH_MASTERS = 'match-masters',
  POKER_FACE = 'pokerFace',
  BAGELCODE = 'bagelcode',
  LOCO_BINGO = 'locobingo',
  ME2ON = 'me2on',
  PIPA = 'pipa',
  BABA = 'baba',
  JACKPOT_SLOTS = 'jackpot-slots',
  BIG_FISH_CASINO = 'big-fish-casino',
  PLAY_SIMPLE = 'play-simple',
  GHOST = 'ghost',
  GHOST_DOUBLE_HIT_CASINO = 'ghost-double-hit-casino',
  BINGO_POP = 'bingo-pop',
  FABEL_TOWN = 'fabel-town',
  DECA = 'deca',
  LOAD_COMPLETE = 'load-complete',
  SPIN_X = 'spin-x',
  CASH_FRENZY = 'cash-frenzy',
  GENNMU = 'gennmu',
  BANDITOS = 'banditos',
  JUNES_JOURNEY = 'junes-journey',
  STUDIO_DEFAULT = 'studio-default',
  DRIMAGE = 'drimage',
  CASHMAN_CASINO = 'cashman-casino',
  MIGHTY_FU = 'mighty-fu',
  ROYAL_MATCH = 'royal-match',
  LIGHTNING_LINK_CASINO = 'lightning-link-casino',
  HEART_OF_VEGAS = 'heart-of-vegas',
  CANDY_CRUSH = 'candy-crush',
  COOKING_MADNESS = 'cooking-madness',
  KONAMI_SLOTS = 'konami-slots',
  BEACHBUM = 'beachbum',
  MGM = 'mgm',
  MY_VEGAS_SLOTS = 'my-vegas-slots',
  MY_VEGAS_CLASSIC = 'my-vegas-classic',
  POP_SLOTS = 'pop-slots'
}

export enum ELogoSize {
  SMALL = 'small',
  BIG = 'big'
}

export enum EProductPriority {
  MAIN = 'Main',
  SUB = 'Sub',
  WEB_ONLY = 'Web Only'
}

export enum EProductType {
  QUANTITY = 'Quantity',
  TIME = 'Time'
}

export enum EFeatureFlag {
  DASHBOARD_OFFERS_FREE = 'dashboard_offers_free',
  DASHBOARD_DISPUTE_EVIDENCES = 'dashboard_dispute_evidences',
  DASHBOARD_TAGS = 'dashboard_tags',
  DASHBOARD_COUPONS = 'dashboard_coupons',
  DASHBOARD_DAILY_BONUS_BADGE = 'dashboard_daily_bonus_badge',
  DASHBOARD_NEW_PRIVACY_RICH_TEXT = 'dashboard_new_privacy_rich_text',
  DASHBOARD_SCHEDULED_OFFERS = 'dashboard_scheduled_offers',
  DASHBOARD_INTERVALS = 'dashboard_intervals',
  STORE_MULTI_LANGUAGE_SUPPORT = 'store_multi_language_support',
  DASHBOARD_GENERATE_DEEPLINK = 'dashboard_generate_deeplink',
  DASHBOARD_CHECKOUT_LINK_FEATURE = 'dashboard_checkout_link_feature',
  DASHBOARD_EVENT_CENTER = 'dashboard_event_center',
  DASHBOARD_BODYBLOCK_SUPPORT_PLAYER_LEVEL = 'dashboard_bodyblock_support_player_level',
  DASHBOARD_REWARD_CALENDAR = 'dashboard_reward_calendar',
  DASHBOARD_TRIGGERED_POPUPS = 'dashboard_triggered_popups',
  DASHBOARD_COMPRESS_UPLOADED_IMAGES = 'dashboard_compress_uploaded_images',
  STORE_HEADER_V2 = 'store_header_version_2',
  STORE_TABS = 'store_tabs',
  DASHBOARD_ROLLING_OFFER_FEATURE = 'dashboard_rolling_offer_feature',
  DASHBOARD_PRICE_POINT_ALERTING = 'dashboard_price_point_alerting',
  DASHBOARD_SDK_AUTO_UPDATER_UI = 'dashboard_sdk_auto_updater_ui',
  COUPONS_ALLOWED_PLAYERS = 'checkout_coupons_allow_list',
  CHECKOUT_SCIPLAY_ANALYTICS = 'checkout_sciplay_analytics',
  DASHBOARD_DEEPLINKS = 'dashboard_deeplinks',
  DASHBOARD_SHOW_LOGIN_BUTTON_PORTAL_STUDIO = 'dashboard_show_login_button_portal_studio',
  DASHBOARD_DISABLE_CURRENCIES = 'dashboard_disable_currencies',
  DASHBOARD_ROLLING_CHEATS = 'dashboard_rolling_cheats',
  DASHBOARD_EXCHANGE_RATE_UPDATE_SCHEDULER = 'dashboard_exchange_rate_update_scheduler',
  DASHBOARD_EVENTS_V2 = 'dashboard_events_v2',
  DASHBOARD_PRODUCT_DESCRIPTION = 'dashboard_product_description',
  DASHBOARD_ROLLING_ARROW_IMAGE = 'dashboard_rolling_arrow_image',
  DASHBOARD_SUBSCRIPTIONS = 'dashboard_subscriptions',
  DASHBOARD_TEMPLATES_STUDIO = 'dashboard_templates_studio',
  DASHBOARD_CHECKOUT_DESIGN = 'dashboard_checkout_design',
  DASHBOARD_PROGRESS_BAR_CHEATS = 'dashboard_progress_bar_cheats',
  DASHBOARD_FB_BUTTON_CONFIG = 'Dashboard_fb_button_config',
  DASHBOARD_CHECKLIST_WIDGET = 'dashboard_checklist_widget',
  DASHBOARD_CHECKOUT_CHECKLIST_WIDGET = 'dashboard_checkout_checklist_widget',
  USE_V2_RECEIPTS_SQS_QUEUE = 'checkout_use_v2_receipts_queue',
  DASHBOARD_DISPLAY_INTEGRATION_OLD_VERSIONS = 'Dashboard_display_integration_old_versions',
  CHECKOUT_V3 = 'checkout_v3',
  DASHBOARD_DISPLAY_DEVELOPER_SETTINGS_PAGE = 'dashboard_display_developer_settings_page',
  DASHBOARD_API_TESTING = 'dashboard_api_testing',
  DASHBOARD_STORE_SEO_SETTINGS = 'dashboard_store_seo_settings',
  DASHBOARD_SHOW_DAILY_RESET_TIMEZONE = 'Dashboard_show_daily_reset_timezone',
  DASHBOARD_MAINTENANCE_MODE_SETTINGS = 'dashboard_maintenance_mode_settings',
  DASHBOARD_DAILY_BONUS_SIDE_MENU = 'Dashboard_daily_bonus_side_menu',
  STORE_CAROUSEL_V2 = 'store_carousel_v2',
  DASHBOARD_CREDENTIALS_V2 = 'credentials_v2',
  DASHBOARD_ROLLING_OFFER_1N_ENABLED = 'dashboard_rolling_offer_1n_enabled',
  DASHBOARD_DISPLAY_SLA_PAGE = 'dashboard_display_sla_page',
  DASHBOARD_SHOW_ROLLING_OFFER_JUNES_JOURNEY_V2 = 'Dashboard_show_rolling_offer_junes_journey_v2',
  DASHBOARD_SHOW_COLLECT_TEXT_PRIOR_COUNTDOWN = 'Dashboard_show_collect_text_prior_countdown',
  DASHBOARD_EU_REFUND_LINK_ENABLED = 'eu_refund_link_enabled',
  REWARD_PROGRESS_BAR_MILESTONES_ENABLED = 'reward_progress_bar_milestones_enabled',
  DASHBOARD_SEND_STOREBLOCKS_TEMPLATE_STUDIO = 'dashboard_send_storeblocks_template_studio'
}

export enum EProgressBarType {
  CLASSIC = 'classic',
  MILESTONE = 'milestone'
}

export enum EStyleProperty {
  fontWeight = 'fontWeight',
  fontFamily = 'fontFamily'
}

export enum EFontWeight {
  Regular = 'regular',
  Medium = 'medium',
  Bold = 'bold'
}

export enum SortingOrderValue {
  STATUS = 'status',
  BUNDLE = 'bundle',
  ID = 'id',
  PROVIDER = 'provider',
  AMOUNT = 'amount',
  PLAYER = 'player',
  DATE = 'date',
  PUBLISHER_ID = 'publisherId'
}

export enum SortingOffersValue {
  ID = 'id',
  PUBLISHER_OFFER_ID = 'publisher_offer_id',
  NAME = 'name',
  CREATED_AT = 'created_at',
  PRICE = 'price',
  STATUS = 'status',
  SCHEDULE = 'schedule'
}

export enum SortingDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export enum OfferType {
  BUNDLE = 'Bundle',
  SPECIAL_OFFER = 'SpecialOffer',
  ONE_PLUS_ONE = 'OnePlusOne',
  BONUS = 'Bonus',
  POPUP = 'PopUp',
  DAILY_BONUS = 'DailyBonus',
  ROLLING_OFFER = 'RollingOffer',
  BUY_ONE_GET_MANY = 'OnePlusMany',
  CHECKOUT_LINK = 'CheckoutLink',
  PROGRESS_BAR = 'ProgressBar',
  REWARD_CALENDAR = 'RewardCalendar'
}

export enum GridFeatureMode {
  CLIENT = 'client',
  SERVER = 'server'
}

export enum EOrderStatus {
  // Valid API statuses only
  created = 'created',
  payment_pending = 'payment_pending',
  payment_succeed = 'payment_succeed',
  payment_failed = 'payment_failed',
  payment_refund_pending = 'payment_refund_pending',
  payment_refund_requires_action = 'payment_refund_requires_action',
  payment_refunded = 'payment_refunded',
  payment_refund_failed = 'payment_refund_failed',
  payment_refund_canceled = 'payment_refund_canceled',
  payment_canceled = 'payment_canceled',
  charge_pending = 'charge_pending',
  charge_succeed = 'charge_succeed',
  charge_failed = 'charge_failed',
  payment_dispute_open = 'payment_dispute_open',
  payment_dispute_lost = 'payment_dispute_lost',
  payment_dispute_won = 'payment_dispute_won',
  payment_dispute_evidence_submitted = 'payment_dispute_evidence_submitted',
  payment_dispute_inquiry_open = 'payment_dispute_inquiry_open',
  payment_dispute_inquiry_evidence_submitted = 'payment_dispute_inquiry_evidence_submitted',
  payment_dispute_inquiry_won = 'payment_dispute_inquiry_won',

  // Deprecated/Invalid statuses (kept for backward compatibility)
  unpaid = 'unpaid',
  payment_expired = 'payment_expired',
  payment_refund_cancelled = 'payment_refund_cancelled'
}

export enum EAwardFlowStatus {
  AUTO = 'auto',
  MANUAL_RETRY = 'manual_retry'
}

export enum EBalancesTheme {
  DEFAULT = 'default',
  BAGELCODE = 'bagelcode',
  SPACEGO = 'spacego',
  PLAYSIMPLE = 'play-simple',
  ME2ON = 'me2on',
  PIPA = 'pipa',
  WHISPERS = 'whispers',
  GHOST = 'ghost',
  GHOST_DOUBLE_HIT_CASINO = 'ghost-double-hit-casino',
  BINGO_POP = 'bingo-pop',
  DECA = 'deca',
  SPIN_X = 'spin-x',
  CASH_FRENZY = 'cash-frenzy',
  LOAD_COMPLETE = 'load-complete',
  PLAYDOG = 'playdog',
  BANDITOS = 'banditos',
  ROYAL_MATCH = 'royal-match'
}

export enum ESectionViewModel {
  DEFAULT = 'default',
  BAGELCODE = 'bagelcode',
  PIPA = 'pipa',
  WHISPERS = 'whispers',
  LLC = 'llc',
  MIGHTY_FU_CASINO = 'mighty-fu-casino',
  GHOST = 'ghost',
  FABEL_TOWN = 'fabel-town',
  SECTION_IMAGE = 'section-image'
}

export enum EActiveState {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum ESetting {
  ROUNDING_ON = 'rounding-on',
  TAX_ON = 'tax-on'
}

export enum ESaleDiscountDisplayType {
  PERCENTAGE = 'percentage',
  MULTIPLIER = 'multiplier',
  FIXED_AMOUNT = 'fixed_amount'
}

export enum EPopupSubType {
  DAILY_BONUS = 'DailyBonus',
  REWARD_CALENDAR = 'RewardCalendar',
  POST_PURCHASE = 'PostPurchase',
  STORE_REFRESH = 'StoreRefresh'
}

export enum EPopupsFormState {
  GENERAL = 'general',
  PRODUCTS = 'products',
  TRIGGERS = 'triggers'
}

export enum ERollingOfferFormState {
  GENERAL = 'general',
  CONFIGURATION = 'configuration',
  SCHEDULE = 'schedule'
}

export enum ERewardCalendarFormState {
  GENERAL = 'general',
  CONFIGURATION = 'configuration',
  OFFER_BEHAVIOR = 'offerBehavior'
}

export enum ERewardCalendarMissedReset {
  TO_CALENDAR_START = 'ToCalendarStart',
  TO_CURRENT_WEEK_START = 'ToCurrentWeekStart'
}

export enum ERewardCalendarPopUpTrigger {
  SHOW_AUTOMATICALLY = 'ShowAutomatically',
  OPEN_ON_BADGE_CLICK = 'ShowOnBadgeClick'
}

export enum ERewardCalendarRewardCollection {
  FORCE_PLAYER_TO_COLLECT = 'ForcePlayerToCollect',
  PLAYER_CAN_SKIP_COLLECTION = 'PlayerCanSkipCollection'
}

export enum EPromotionsFormState {
  GENERAL = 'general',
  SCHEDULE = 'schedule'
}

export enum ECouponsFormState {
  SETTINGS = 'settings'
}

export enum EAppearanceStatus {
  UPCOMING = 'Upcoming',
  RUNNING = 'Running',
  ENDED = 'Ended'
}

export enum EOfferStatus {
  UPCOMING = 'Upcoming',
  RUNNING = 'Running',
  ENDED = 'Ended',
  INTERVAL = 'Interval',
  PERMANENT = 'Permanent',
  INACTIVE = 'Inactive',
  PENDING_SAVE = 'Pending Save'
}

export enum EPendingAppearanceStatus {
  PENDING_SAVE = 'Pending Save'
}

export enum EWeekDay {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY
}

export enum EIntervalsRepeat {
  NONE = 'none',
  DAILY = 'Every day',
  WEEKLY = 'Every week',
  MONTHLY = 'Every month',
  QUARTERLY = 'Quarterly',
  SEMI_ANNUALLY = 'Semi-annually',
  ANNUALLY = 'Annually'
}

export enum EIntervalsRepeatRequired {
  DAILY = 'Every day',
  WEEKLY = 'Every week',
  MONTHLY = 'Every month'
}

export enum EScheduleType {
  PERMANENT = 'Permanent',
  SCHEDULED = 'Scheduled'
}

export enum EScheduleTabs {
  PERMANENT = 'Permanent',
  SCHEDULE = 'Schedule',
  INTERVALS = 'Intervals'
}

export enum EBrandKitTabs {
  BRANDING = 'Branding',
  EXTERNAL_BUTTONS = 'External Buttons'
}

export enum ECheckoutLinkTabs {
  SETTINGS = 'Settings',
  SCHEDULE = 'Schedule'
}

export enum EButtonColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}

export enum EButtonVariant {
  TEXT = 'text',
  OUTLINED = 'outlined',
  CONTAINED = 'contained'
}

export enum UploadTypes {
  STATIC = 'static',
  DYNAMIC = 'dynamic'
}

export enum ELogoutMessage {
  OUTDATED_VERSION = 'Outdated version',
  SESSION_EXPIRED = 'Your session has expired. Please log in again.'
}

export enum EEventCategories {
  WEB_STORE = 'Webstore Events',
  CHECKOUT = 'Payment Events',
  NEW = 'New Events',
  PORTAL = 'Portal Events'
}

export enum EEventSubCategories {
  LOGIN = 'Login Event',
  STORE = 'Store Interaction',
  ERROR = 'Error Event',
  CHECKOUT_LINKS = 'Checkout Links',
  ORDER = 'Order Event',
  DISPUTE = 'Dispute Event',
  UNKNOWN = 'Unknown',
  PROGRESS_BAR = 'Progress Bar',
  PORTAL = 'Portal Interaction'
}

export const Events = {
  [EEventCategories.WEB_STORE]: [
    EPublisherEventValue.LOGIN_LAND,
    EPublisherEventValue.LOGIN_METHOD_SELECTED,
    EPublisherEventValue.LOGIN_CANCELED,
    EPublisherEventValue.LOGIN_RESOLVED,
    EPublisherEventValue.SHOP_LAND,
    EPublisherEventValue.OFFERS_SHOWN,
    EPublisherEventValue.OFFERS_LOADED,
    EPublisherEventValue.POPUP_CLOSED,
    EPublisherEventValue.INVALID_PROPERTY_ERROR,
    EPublisherEventValue.APPROVAL_REQUEST_CLOSED,
    EPublisherEventValue.APPROVAL_REQUEST_DISPLAYED,
    EPublisherEventValue.WEBSTORE_PERSONALIZATION_ERROR_INVALID_PROPERTY,
    EPublisherEventValue.WEBSTORE_PERSONALIZATION_ERROR,
    EPublisherEventValue.WEBSTORE_OFFERS_LOADED,
    EPublisherEventValue.WEBSTORE_OFFERS_DISPLAYED,
    EPublisherEventValue.WEBSTORE_APPROVAL_REQUEST_DISPLAYED,
    EPublisherEventValue.WEBSTORE_APPROVAL_REQUEST_CLOSED,
    EPublisherEventValue.WEBSTORE_LOGIN_DISPLAYED,
    EPublisherEventValue.WEBSTORE_STORE_DISPLAYED,
    EPublisherEventValue.WEBSTORE_LOGIN_METHOD_SELECTED,
    EPublisherEventValue.WEBSTORE_LOGIN_CANCELED,
    EPublisherEventValue.WEBSTORE_LOGIN_COMPLETED,
    EPublisherEventValue.WEBSTORE_PROGRESS_BAR_MISSION_COMPLETED,
    EPublisherEventValue.WEBSTORE_PROGRESS_BAR_MISSION_STARTED,
    EPublisherEventValue.WEBSTORE_PROGRESS_BAR_POINTS_GRANTED,
    EPublisherEventValue.WEBSTORE_POPUP_TRIGGERED,
    EPublisherEventValue.WEBSTORE_BADGE_CLICKED,
    EPublisherEventValue.WEBSTORE_OFFER_CLICKED
  ],
  [EEventCategories.CHECKOUT]: [
    EPublisherEventValue.ORDER_CREATED,
    EPublisherEventValue.PAYMENT_INTENT_SUCCESS,
    EPublisherEventValue.PAYMENT_INTENT_FAILED,
    EPublisherEventValue.ORDER_COMPLETED_SUCCESS,
    EPublisherEventValue.ORDER_COMPLETED_FAILED,
    EPublisherEventValue.ORDER_CANCELED,
    EPublisherEventValue.ORDER_REFUNDED,
    EPublisherEventValue.ORDER_DISPUTE_OPEN,
    EPublisherEventValue.ORDER_DISPUTE_WON,
    EPublisherEventValue.ORDER_DISPUTE_LOST,
    EPublisherEventValue.ORDER_ORDER_CREATED,
    EPublisherEventValue.ORDER_ORDER_PAYMENT_RESOLVED,
    EPublisherEventValue.ORDER_ORDER_COMPLETED,
    EPublisherEventValue.ORDER_ORDER_REFUNDED,
    EPublisherEventValue.ORDER_ORDER_DISPUTE_OPENED,
    EPublisherEventValue.ORDER_ORDER_DISPUTE_RESOLVED,
    EPublisherEventValue.ORDER_ORDER_CANCELED,
    EPublisherEventValue.ORDER_REFUND_FAILED
  ],
  [EEventCategories.PORTAL]: [
    EPublisherEventValue.PORTAL_LOGIN_DISPLAYED,
    EPublisherEventValue.PORTAL_LOGIN_METHOD_SELECTED,
    EPublisherEventValue.PORTAL_LOGIN_CANCELED,
    EPublisherEventValue.PORTAL_LOGIN_COMPLETED,
    EPublisherEventValue.PORTAL_PAGE_DISPLAYED,
    EPublisherEventValue.PORTAL_CONTENT_DISPLAYED,
    EPublisherEventValue.PORTAL_BLOCK_CLICKED,
    EPublisherEventValue.PORTAL_FOOTER_CLICKED
  ]
};

export enum StoreBodyBlock {
  dailyBonusBadge = 'dailyBonus',
  playerLevel = 'playerLevel',
  banners = 'banners',
  progressBars = 'progressBars',
  specialOffers = 'specialOffers',
  rollingOffers = 'rollingOffers',
  onePlusMany = 'onePlusMany',
  bundles = 'bundles',
  richText = 'richText',
  rewardCalendar = 'rewardCalendar',
  triggeredPopups = 'triggeredPopups'
}

export enum EEventsType {
  DASHBOARD_SIGNUP_LANDED = 'DASHBOARD_SIGNUP_LANDED',
  DASHBOARD_SIGNUP_COMPLETED = 'DASHBOARD_SIGNUP_COMPLETED',
  DASHBOARD_EMAIL_VERIFICATION_CLICKED = 'DASHBOARD_EMAIL_VERIFICATION_CLICKED',
  DASHBOARD_BUSINESS_INFO_SUBMITTED = 'DASHBOARD_BUSINESS_INFO_SUBMITTED',
  DASHBOARD_BUSINESS_VERIFICATION_SUBMITTED = 'DASHBOARD_BUSINESS_VERIFICATION_SUBMITTED',
  DASHBOARD_SETUP_GUIDE_TASK_CLICKED = 'DASHBOARD_SETUP_GUIDE_TASK_CLICKED',
  DASHBOARD_SETUP_GUIDE_TASK_COMPLETED = 'DASHBOARD_SETUP_GUIDE_TASK_COMPLETED',
  DASHBOARD_TEST_PAYMENT_COMPLETED = 'DASHBOARD_TEST_PAYMENT_COMPLETED',
  DASHBOARD_AGREEMENT_REQUEST_CLICKED = 'DASHBOARD_AGREEMENT_REQUEST_CLICKED',
  DASHBOARD_TEMPLATE_ACTION = 'DASHBOARD_TEMPLATE_ACTION',
  DASHBOARD_PAGE_DISPLAYED = 'DASHBOARD_PAGE_DISPLAYED',
  DASHBOARD_SIDEBAR_CLICKED = 'DASHBOARD_SIDEBAR_CLICKED',
  DASHBOARD_API_TEST_OPEN_MODAL = 'DASHBOARD_API_TEST_OPEN_MODAL',
  DASHBOARD_API_TEST_CLICKED = 'DASHBOARD_API_TEST_CLICKED',
  DASHBOARD_API_INTEGRATION_SAVED = 'DASHBOARD_API_INTEGRATION_SAVED',
  DASHBOARD_API_DOCS_CLICKED = 'DASHBOARD_API_DOCS_CLICKED'
}

export enum EDashboardPage {
  LOGIN = 'login',
  OTP = 'otp',
  LOCKOUT = 'lockout',
  DASHBOARD = 'dashboard',
  SIGNUP = 'signup'
}

export enum ELockoutSource {
  PASSWORD = 'password',
  OTP = 'otp'
}

export enum ESignUpMethod {
  EMAIL = 'email',
  GOOGLE = 'google'
}

export enum EPaymentFlow {
  SUBSCRIPTION_FIRST_PAYMENT = 'Subscription (first)',
  SUBSCRIPTION_PAYMENT = 'Subscription',
  SINGLE_PAYMENT = 'Single payment'
}

export enum EPosition {
  LEFT = 'left',
  RIGHT = 'right'
}
